import PageInFlowWithSidebarLayout, {
  PageInFlowWithSidebarLayoutProps,
} from 'components/common/general/layouts/PageInFlowWithSidebarLayout';
import React from 'react';
import EnrollmentFlowPage from 'store/flows/enrollment/enrollmentFlowPage';
import { observer } from 'mobx-react-lite';
import EnrollmentSidebar from './EnrollmentSidebar';
import GroupInfoBlob from './GroupInfoBlob';

interface EnrollmentFlowLayoutProps extends Omit<PageInFlowWithSidebarLayoutProps, 'sidebar' | 'moreInfoBlob'> {
  pageStore: EnrollmentFlowPage;
  isPageLoading?: boolean;
}

const EnrollmentFlowLayout: React.FC<EnrollmentFlowLayoutProps> = observer(
  ({ pageStore, pageId, isPageLoading, ...rest }) => {
    const { infoBlobData } = pageStore.groupInfoDelegate;
    return (
      <PageInFlowWithSidebarLayout
        {...rest}
        moreInfoBlob={{
          title: infoBlobData?.groupName || '',
          infoTextTitle: 'More Info',
          popOver: {
            content: (
              <GroupInfoBlob
                effectiveDate={infoBlobData?.effectiveDate || ''}
                groupName={infoBlobData?.groupName || ''}
              />
            ),
          },
        }}
        pageId={pageId}
        sidebar={<EnrollmentSidebar sidebarDelegate={pageStore.sidebarDelegate} />}
        isInitialLoading={isPageLoading}
        isInfoSectionLoading={pageStore.groupInfoDelegate.isFlowDataLoading}
      />
    );
  },
);

export default EnrollmentFlowLayout;
